<template>
  <div class="main-content">
    <div class="container cv-content">
      <div class="cv-element" v-for="e in contents">
        <h3 style="margin-bottom: 12px">{{e.title}}</h3>
        <table class="table table-borderless table-sm" v-if="e.type === 'table' || e.type === 'listed-table'">
          <tr v-for="row in e.content">
            <td :class="e.style_title" v-html="row[0] " v-if="e.type === 'listed-table'"></td>
            <td :class="e.style_title" v-html="row[0]" v-else></td>
            <td :class="e.style_content" v-html="row[1]"></td>
          </tr>
        </table>
        <ul v-else-if="e.type === 'list'">
          <li v-for="row in e.content" class="info-list-row">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </li>
        </ul>
        <table class="table table-borderless table-sm" v-else-if="e.type === 'work'">
          <tr v-for="row in e.content">
            <td class="work-date" v-html="row.date"></td>
            <td :class="e.style_content">
              <span class="work-at">{{row.at}}</span> <br>
              <span class="work-position">
                {{row.position}}
              </span>
              <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>
              <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>
              <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>
              <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>
              <br>

              <span class="work-description">{{row.description}}</span>
            </td>
          </tr>
        </table>
        <div v-else>
          <p v-for="row in e.content">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Works',
  components: {},
  mounted() {
    // $('body').css('overflow', 'auto'); //TODO
  },
  data() {
    return {
      contents: [
        {
        order: 1000,
        type: 'work',
        title: "Employments",
        style_title: "info-bold",
        style_content: "info-regular",
        content: [
          {
            date: "Jul. 2015 ~ Sep. 2015",
            at: "CLBee System Co., Ltd.",
            position: "Developer",
            description: "Android application development",
            icon: ["developer"]
          },
          {
            date: "Sep. 2015 ~ Dec. 2015",
            at: "4th Creative Invention Class STEP 4, Korea Invention Promotion Association ",
            position: "Mentor",
            description: "Robotics (Arduino and basic electronics) for elementary school students",
            icon: ["instructor"]
          },
          {
            date: "Sep. 2016 ~ Dec. 2018",
            at: "KAIST Cyber Talented Center, KAIST Global Institute for Talented Education",
            position: "Tutor",
            description: "C language class",
            icon: ["instructor"]
          },
          {
            date: "Dec. 2016 ~ Mar. 2017",
            at: "KAIST Cyber Talented Center, KAIST Global Institute for Talented Education",
            position: "Course Developer",
            description: "C language course design and development",
            icon: ["instructor"]
          },
          {
            date: "Mar. 2017 ~ Dec. 2018",
            at: "KAIST Humanity/Leadership III Course <Basic Robotics> (HSS062)",
            position: "Instructor",
            description: "Basic robotics for freshman students",
            icon: ["instructor"]
          },
          {
            date: "Dec. 2017 ~ Feb. 2018",
            at: "SPS Inc., Ltd.",
            position: "Intern",
            description: "Real-Time Location System",
            icon: ["developer"]
          },
          {
            date: "Oct. 2018 ~ Dec. 2018",
            at: "KAIST Idea Factory",
            position: "Manager",
            description: "Maker space (Prototyping room) opening preparation and management.",
            icon: ["maker"]
          },
          {
            date: "Jun. 2019 ~ May. 2022",
            at: "Agency for Defense Development (ADD)",
            position: "Research Officer for National Defense",
            description: "Research for ground technology",
            icon: ["researcher"]
          }]
        },
        {
          order: 1200,
          type: 'listed-table',
          title: "Skills",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["Advanced Level",
            "Programming in Java, Android, Arduino<br>"],
            ["Intermediate Level",
            "Programming in C, C++, Python, Javascript<br>" +
            "Microsoft Office (Word, Excel, Powerpoint)<br>" +
            "Server(Ubuntu) management and maintenance<br>" +
            "Web development (JSP, jQuery, HTML5)<br>" +
            "Adobe Photoshop<br>" +
            "Circuit design with Arduino"],
            ["Basic Level",
            "Designing H/W with AutoCAD, SolidWorks<br>Adobe Premiere Pro<br>" +
            "Spring framework<br>" +
            "Hardware design in VHDL"],
          ]
        },
        {
          order: 1300,
          type: 'list',
          title: "Qualifications",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["Engineer Computer System Application<br>", "National Technical Qualification, 28 Aug. 2020.-"],
            ["Engineer Computer<br>", "National Technical Qualification, 31 Dec. 2020.-"],
          ]
        },
      ]}
  }
}
</script>

<style>
#app {
}
body {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Works.vue